import Vue from 'vue';
import MessageVue from './index.vue';

// 定义插件对象
const LutticaMessage = {};
// vue的install方法用于定义vue插件
LutticaMessage.install = vue => {
  const LutticaMessageInstance = vue.extend(MessageVue);
  let currentMessage;
  const initInstance = () => {
    // 实例化vue实例
    currentMessage = new LutticaMessageInstance();
    const msgBoxEl = currentMessage.$mount().$el;
    document.body.appendChild(msgBoxEl);
  };
  // 在vue的原型上添加实例方法，以全局调用
  Vue.prototype.$lutticaMessage = {
    info(options) {
      if (!currentMessage) {
        initInstance();
      }
      if (typeof options === 'string') {
        currentMessage.content = options;
      } else if (typeof options === 'object') {
        Object.assign(currentMessage, options);
      }
      return currentMessage
        .showLutticaMessage()
        .then(val => {
          currentMessage = null;
          return Promise.resolve(val);
        })
        .catch(err => {
          currentMessage = null;
          return Promise.reject(err);
        });
    },
    remove() {
      if (currentMessage && currentMessage.$mount().$el) {
        document.body.removeChild(currentMessage.$mount().$el);
      }
    },
  };
};
export default LutticaMessage;
